/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import {LOADER_STATUS, SUPPLIER_INFO, SUPPLIER_TRACK_RETURN} from './constants';

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  supplierInfo: '',
  supplierTrackReturn: ''
};


/* eslint-disable default-case, no-param-reassign */
const gstrSupplierInfoReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
        case SUPPLIER_INFO:
          return {
            ...state,
            supplierInfo:action.supplierInfo
          }       
        case SUPPLIER_TRACK_RETURN:
          return {
            ...state,
            supplierTrackReturn:action.supplierTrackReturn
          }
        default:
          return state;
    }
  };

export default gstrSupplierInfoReducer;
